module.exports = __webpack_public_path__ + "front/img/b29.be8beaf1.jpg";